import { createStore } from 'effector'
import { Kyc } from './kyc'

export const $kyc = createStore(new Kyc(null))
